import React, { Component } from 'react'
import { connect } from 'react-redux'
import Checkbox from 'components/Controls/Checkbox'
import StyledFlagSetter from './StyledFlagSetter'
import Modal from '../Modal'
import { FLAG_SETTER_MODAL } from '../modalTypes'
import { setFlag, localLogout as logout, localLogin as login, fetchMyProfile, clearModal } from 'store/actions'
import { colorThemes } from 'mocks/themes'

const refreshNeeded = /reduxLogger|randomRatings|gaTracker|gaDebug/

class FlagSetter extends Component {
  onCheckboxChange = ({ target: { name, checked } }) => {
    this.props.setFlag(name, checked || '')
    if (name == 'guest') {
      return (checked ? logout : login)().then(this.props.fetchMyProfile)
    }
    if (name == 'disableCCP' && checked) {
      document.querySelector('body').classList.remove('chat-on', 'chat-open', 'chat-closed')
    }
    if (name == 'themeEditor' || name == 'themePreview') {
      this.props.clearModal(FLAG_SETTER_MODAL)
      window.theme[name == 'themeEditor' ? 'edit' : 'preview'](+checked)
    }
    refreshNeeded.test(name) && location.reload()
  };
  onKeyDown = ({ key, target }) => key == 'Enter' && this.onTextFieldChange({ target });

  onButtonClick = ({ target: { name } }) =>
    this.onTextFieldChange({ target: document.querySelector(`[name=${name.replace('-btn', '')}]`) });

  onTextFieldChange = ({ target: { name, value } }) => {
    this.props.setFlag(name, value || '')
    login().then(this.props.fetchMyProfile)
  };

  renderTextField = name => {
    const props = {
      email: { type: 'email' },
      user: { type: 'number', min: 0, max: 3, autoComplete: 'off' },
      gaTracker: { type: 'text' },
    }
    return (
      <div className="input-wrapper">
        <input name={name} {...props[name]} defaultValue={this.props.flags[name]} onKeyDown={this.onKeyDown} />
        <button name={name + '-btn'} onClick={this.onButtonClick}>
          &rarr;
        </button>
      </div>
    )
  };

  onThemeChange = e => {
    window.theme[e.target.value]()
    this.props.setFlag('themeEditor', '')
  };

  render() {
    const { flags } = this.props
    const themes = { siteStyles: JSON.parse(sessionStorage.siteStyles), ...colorThemes }

    return (
      <Modal transparentBackground modalId={FLAG_SETTER_MODAL}>
        <StyledFlagSetter>
          {Object.entries(window.flags).map(([title, group]) => (
            <section key={title}>
              <h1>{title}</h1>
              {Object.entries(group).map(([name, description]) => (
                <label className="setting" key={name}>
                  <strong>
                    {name}
                    {refreshNeeded.test(name) && <sup title="Will reload the page">*</sup>}
                  </strong>
                  {/email|user|gaTracker/.test(name) ? (
                    this.renderTextField(name)
                  ) : name == 'theme' ? (
                    <select defaultValue={sessionStorage.theme} onChange={this.onThemeChange}>
                      {Object.keys(themes).map(name => (
                        <option value={name} key={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <Checkbox name={name} checked={!!flags[name]} onChange={this.onCheckboxChange} />
                  )}

                  <p>{description}</p>
                </label>
              ))}
            </section>
          ))}
        </StyledFlagSetter>
      </Modal>
    )
  }
}

export default connect(({ flags }) => ({ flags }), { setFlag, clearModal, fetchMyProfile })(FlagSetter)
